// n8n Configuration
// SAFE TO EDIT - This file is NOT included in updates
// Place your n8n instance details here

const n8nConfig = {
  // Your n8n instance URL (no trailing slash)
  baseUrl: "https://n8n.hyveappliedintelligence.com",

  // Your n8n API key
  // Get it from: n8n Settings → API → Create API Key
  apiKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJlOGMwZjdjOS04NGZjLTQwYzgtYjZkNS1kMTVhYzJiYzhjOTAiLCJpc3MiOiJuOG4iLCJhdWQiOiJwdWJsaWMtYXBpIiwiaWF0IjoxNzY0NjMyMjM5fQ.Fpvz_z79WK-l9F8LEjPHXFp-RXAuCEUbVW6UY8OU7j8",

  // Optional: Default settings
  defaultLimit: 100,
  includeData: false,

  // ==========================================
  // Vector Database Configuration (Pinecone)
  // ==========================================

  vector: {
    // Pinecone API Key
    // Get it from: https://app.pinecone.io/ → API Keys
    apiKey:
      "pcsk_4qkcER_SCekYyuxvk4ccGpWeiTyibhCuzpebu5cLPWFr3b4D33Q3cRuxNFe267Gxr6YASm",

    // Pinecone Environment
    // Example: 'us-east-1-aws', 'us-west1-gcp', 'eu-west1-gcp'
    environment: "https://email2-84qtrz3.svc.aped-4627-b74a.pinecone.io",

    // Default Index Name
    // The Pinecone index to use for vector operations
    indexName: "email2",

    // Namespace (optional)
    // Logical partition within an index
    namespace: "SentinelAZ",

    // Vector Dimensions
    // Must match your embedding model (e.g., 1536 for OpenAI ada-002)
    dimensions: 1024,

    // Similarity Metric
    // Options: 'cosine', 'euclidean', 'dotproduct'
    metric: "cosine",

    // Top K Results
    // Number of similar results to return
    topK: 10,

    // Minimum Score Threshold
    // Only return results above this similarity score (0-1)
    minScore: 0.7,
  },
};

export default n8nConfig;

// EXAMPLE CONFIGURATIONS:

// Example 1: Local n8n instance
// baseUrl: 'http://localhost:5678',
// apiKey: 'n8n_api_1234567890abcdef',

// Example 2: Cloud n8n instance
// baseUrl: 'https://myworkspace.app.n8n.cloud',
// apiKey: 'n8n_api_abcdef1234567890',

// Example 3: Self-hosted with custom domain
// baseUrl: 'https://n8n.yourdomain.com',
// apiKey: 'n8n_api_xyz123abc456',
